import { useState, useEffect } from 'react';
import { format } from 'date-fns';
import { it } from 'date-fns/locale';

export default function LiveClock() {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <time className="text-gray-300 font-mono text-sm tabular-nums">
      {format(now, 'dd/MM/yyyy HH:mm:ss', { locale: it })}
    </time>
  );
}
